import { NavLink } from "react-router-dom";

const Content = () => {

  return (
    <>
      <article className="flex w-0 flex-1 flex-col gap-6 py-10">
        <div className="prose">
          <h1>О проекте</h1>
          <p>
            Мы создаем интернет-магазин автозапчатей, который решает главные
            проблемы автолюбителей и мастеров:
            медленные сайты, сложный поиск и неудобное управление заказами.
            Наш сервис будет быстрым, интуитивным и надежным, что бы Вы могли 
            легко найти нужную запчасть и контролировать её доставку.
          </p>
          <h2>Миссия проекта</h2>
          <p>
            Создать лучший интернет-магазин автозапчатей, где каждая деталь
            найдётся быстро, покупка будет простой, а управление заказами —
            удобным и понятным. Мы работаем, что бы Вы экономили время
            и получали только положительные эмоции от работы с сайтом.
          </p>
          <h2>Преимущества нашего проекта</h2>
          <ul className="ul-main">
            <li>Высокая скорость работы</li>
            <p>
              Забудьте о медленных загрузках и долгом поиске — наш сайт
              работает быстрее большинства конкурентов.
            </p>
            <li>Современный и продуманный дизайн</li>
            <p>
              Интуитивно понятный интерфейс делает покупку запчастей простой и 
              приятной даже для новичков.
            </p>
            <li>Удобный личный кабинет</li>
            <p>
              Следите за статусом заказа, управляйте доставкой и получайте обновления
              в реальном времени.
            </p>
            <li>Умный поиск и фильтры</li>
            <p>
              Находите нужные запчасти по VIN-коду, категории или характеристикам
              без лишних усилий
            </p>
            <li>Обширный каталог</li>
            <p>
              Детали для всех популярных марок и моделей автомобилей собраны в одном месте
            </p>
            <li>Поддержка 24/7</li>
            <p>
              Мы готовы помочь Вам в любое время дня.
            </p>
          </ul>
        </div>
        <div className="mt-4 flex flex-row flex-wrap gap-4 border-t py-12">
          <NavLink className="flex flex-row items-center gap-2 text-muted-foreground transition-colors hover:text-foreground ms-auto" to="/capability">
            <p className="text-end font-medium text-foreground">
              Функционал
            </p>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-chevron-right size-5 shrink-0 rtl:rotate-180">
              <path d="m9 18 6-6-6-6">
              </path>
            </svg>
          </NavLink>
        </div>
      </article>
    </>
  );
};

export default Content;